import styled from 'styled-components';

const ShowstopperGridContainer = styled.li<{
    columnCount?: number;
}>`
    position: relative;
    height: 100%;
    overflow: hidden;
    width: 100%;
    grid-column: ${props => (props.columnCount ? `1 / span ${props.columnCount}` : '1 / -1')};
`;

const ShowstopperMobileContainer = styled.li`
    margin-bottom: 3%;
`;

export { ShowstopperGridContainer, ShowstopperMobileContainer };
